export type Platform = (typeof PLATFORMS)[keyof typeof PLATFORMS];

export const PLATFORMS = {
	ADMIN: "admin",
	DRIVER: "driver",
	FLEET: "fleet",
} as const;
